import { useState } from "react";
import {
   fetchFleetAssignmentDriverList,
   fetchFleetAssignmentFleetList,
   unassignFleetApiCall,
   updateFleetAssignmentApiCall,
} from "../Api/api";
import toast from "react-hot-toast";

const useFleetAssignment = () => {
   const [rawDriverList, setRawDriverList] = useState([]);
   const [rawFleetList, setRawFleetList] = useState([]);

   const [driverList, setDriverList] = useState([]);
   const [fleetList, setFleetList] = useState([]);

   const [unAssignFleetList, setUnAssignFleetList] = useState([]);

   const getDriverList = async () => {
      try {
         const response = await fetchFleetAssignmentDriverList();
         const data = response?.data?.res ?? [];
         setRawDriverList(data);
         setDriverList(
            data.map((d) => ({
               label: d.name,
               value: d.id,
            })),
         );
      } catch (error) {
         ////toast.error("Failed to fetch driver list")
      }
   };

   const getFleetList = async () => {
      try {
         const response = await fetchFleetAssignmentFleetList();
         const data = response?.data?.res ?? [];
         setRawFleetList(data);
         setFleetList(
            data.map((f) => ({
               label: f.vehicle_no,
               value: f.id,
            })),
         );
      } catch (error) {
         ////toast.error("Failed to fetch fleet list")
      }
   };

   const updateFleetAssignment = async (data) => {
      try {
         const response = await updateFleetAssignmentApiCall(data);
         if (response?.data?.statusCode === 200) {
            toast.success(response?.data?.message);
            return response;
         } else {
            ////toast.error(response?.data?.message)
         }
      } catch (error) {
         ////toast.error("Failed to update fleet assignment")
      }
   };

   const unAssignFleet = async () => {
      try {
         const response = await unassignFleetApiCall();
         return response;
      } catch (error) {
         ////toast.error("Failed to unassign driver")
      }
   };

   return {
      driverList,
      fleetList,
      rawDriverList,
      rawFleetList,
      getDriverList,
      getFleetList,
      updateFleetAssignment,
      unAssignFleet,
   };
};

export default useFleetAssignment;
